import { render } from "./Edit.vue?vue&type=template&id=bee77d9e"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Assessments/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bee77d9e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bee77d9e', __exports__)) {
    console.log('reload')
    api.reload('bee77d9e', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=bee77d9e", () => {
    console.log('re-render')
    api.rerender('bee77d9e', render)
  })

}


export default __exports__